// extracted by mini-css-extract-plugin
module.exports = {"description":"ConfirmTenderReady_description__bLjQ6"};